<ion-app [class.user-logged-in]="loginStatus">
  <ion-split-pane contentId="main-content">
    <ion-menu *ngIf="loginStatus" contentId="main-content" type="overlay" menuId="principalMenu" [class.menu-collapsed]="isMenuCollapsed">
      <ion-content class="menu-content">
        <!-- Collapse Button (Desktop Only) -->
        <div class="menu-collapse-button" (click)="toggleMenuCollapse()" role="button" tabindex="0">
          <ion-icon [name]="isMenuCollapsed ? 'chevron-forward-outline' : 'chevron-back-outline'"></ion-icon>
        </div>

        <!-- Menu Header -->
        <div class="menu-header">
          <div class="header-content">
            <div class="user-avatar">
              <div class="avatar-circle">
                <img
                  *ngIf="seller?.logo"
                  [src]="seller.logo"
                  alt="Avatar"
                  class="avatar-image"
                />
                <span *ngIf="!seller?.logo" class="avatar-initials">{{ user?.name?.charAt(0)?.toUpperCase() || 'U' }}</span>
              </div>
              <div class="avatar-status online"></div>
            </div>
            <div class="header-text" *ngIf="!isMenuCollapsed">
              <div class="user-info" *ngIf="loginStatus">
                <h3 class="user-name">{{ user?.name || 'Usuário' }}</h3>
                <p class="user-email">{{ user?.email }}</p>
                <span class="user-type-badge" *ngIf="user?.type === 'seller'">
                  <ion-icon name="storefront-outline"></ion-icon>
                  Vendedor
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Menu Navigation -->
        <div class="menu-navigation">
          <!-- User Pages Section - Hidden during onboarding -->
          <div class="menu-section" *ngIf="appPagesUser.length > 0 && !isInOnboardingMode">
            <h4 class="section-title" *ngIf="!isMenuCollapsed">Navegação</h4>
            <div class="menu-items">
              <div *ngFor="let p of appPagesUser">
                <ion-menu-toggle *ngIf="!p?.needsLogin || user?.id" auto-hide="false">
                  <div class="menu-item" (click)="navigateMenu(p.param)" role="button" tabindex="0" [title]="isMenuCollapsed ? p.title : ''">
                    <div class="item-icon">
                      <ion-icon [name]="p.icon"></ion-icon>
                    </div>
                    <div class="item-content" *ngIf="!isMenuCollapsed">
                      <span class="item-title">{{ p.title }}</span>
                      <ion-badge *ngIf="p.param === 'profile/notifications' && notificationUnreadCount > 0" color="primary" class="menu-badge" style="max-width: 20px;">{{ notificationUnreadCount }}</ion-badge>
                    </div>
                    <div class="item-arrow" *ngIf="!isMenuCollapsed">
                      <ion-icon name="chevron-forward-outline"></ion-icon>
                    </div>
                  </div>
                </ion-menu-toggle>
              </div>
            </div>
          </div>

          <!-- Expert Pages Section - Show "Fale com o especialista" during onboarding for support -->
          <div class="menu-section" *ngIf="(appPagesExpert.length > 0 && !isInOnboardingMode) || isInOnboardingMode">
            <h4 class="section-title" *ngIf="!isMenuCollapsed && !isInOnboardingMode">Especialista</h4>
            <h4 class="section-title" *ngIf="!isMenuCollapsed && isInOnboardingMode">Suporte</h4>
            <div class="menu-items">
              <ion-menu-toggle auto-hide="false" *ngFor="let p of appPagesExpert">
                <!-- During onboarding, only show "Fale com o especialista" -->
                <div *ngIf="!isInOnboardingMode || p.param === 'toWhatsapp'" class="menu-item" (click)="navigateMenu(p.param)" role="button" tabindex="0" [title]="isMenuCollapsed ? p.title : ''">
                  <div class="item-icon">
                    <ion-icon [name]="p.icon"></ion-icon>
                  </div>
                  <div class="item-content" *ngIf="!isMenuCollapsed">
                    <span class="item-title">{{ p.title }}</span>
                  </div>
                  <div class="item-arrow" *ngIf="!isMenuCollapsed">
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  </div>
                </div>
              </ion-menu-toggle>
            </div>
          </div>

          <!-- Additional Actions Section - Hidden during onboarding -->
          <div class="menu-section" *ngIf="!isInOnboardingMode">
            <h4 class="section-title" *ngIf="!isMenuCollapsed">Ações</h4>
            <div class="menu-items">
              <ion-menu-toggle auto-hide="false">
                <div
                  class="menu-item seller-action"
                  *ngIf="user?.type === 'seller'"
                  (click)="navigateMenu('/logged-seller/home')"
                  role="button"
                  tabindex="0"
                  [title]="isMenuCollapsed ? 'Área do Vendedor' : ''"
                >
                  <div class="item-icon">
                    <ion-icon name="wallet-outline"></ion-icon>
                  </div>
                  <div class="item-content" *ngIf="!isMenuCollapsed">
                    <span class="item-title">Área do Vendedor</span>
                    <span class="item-subtitle">Gerenciar sua loja</span>
                  </div>
                  <div class="item-arrow" *ngIf="!isMenuCollapsed">
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  </div>
                </div>

                <div
                  class="menu-item become-seller-action"
                  *ngIf="user?.type !== 'seller'"
                  (click)="navigateMenu('/seller-select')"
                  role="button"
                  tabindex="0"
                  [title]="isMenuCollapsed ? 'Quero ser Vendedor' : ''"
                >
                  <div class="item-icon">
                    <ion-icon name="storefront-outline"></ion-icon>
                  </div>
                  <div class="item-content" *ngIf="!isMenuCollapsed">
                    <span class="item-title">Quero ser Vendedor</span>
                    <span class="item-subtitle">Comece a vender no iPlanta</span>
                  </div>
                  <div class="item-arrow" *ngIf="!isMenuCollapsed">
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  </div>
                </div>

                <div class="menu-item" routerLink="/terms" role="button" tabindex="0" [title]="isMenuCollapsed ? 'Termos de Uso' : ''">
                  <div class="item-icon">
                    <ion-icon name="document-text-outline"></ion-icon>
                  </div>
                  <div class="item-content" *ngIf="!isMenuCollapsed">
                    <span class="item-title">Termos de Uso</span>
                    <span class="item-subtitle">Políticas de privacidade</span>
                  </div>
                  <div class="item-arrow" *ngIf="!isMenuCollapsed">
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  </div>
                </div>
              </ion-menu-toggle>
            </div>
          </div>
        </div>

        <!-- Menu Footer -->
        <div class="menu-footer">
          <div class="footer-actions">
            <ion-menu-toggle auto-hide="false">
              <div
                class="menu-item logout-action"
                data-testid="menu-logout-btn"
                *ngIf="loginStatus"
                (click)="toLogout()"
                role="button"
                tabindex="0"
                [title]="isMenuCollapsed ? 'Sair' : ''"
              >
                <div class="item-icon">
                  <ion-icon name="log-out-outline"></ion-icon>
                </div>
                <div class="item-content" *ngIf="!isMenuCollapsed">
                  <span class="item-title">Sair</span>
                </div>
              </div>

              <div
                class="menu-item login-action"
                data-testid="menu-login-btn"
                *ngIf="!loginStatus"
                (click)="toLogin()"
                role="button"
                tabindex="0"
                [title]="isMenuCollapsed ? 'Entrar ou Cadastrar' : ''"
              >
                <div class="item-icon">
                  <ion-icon name="log-in-outline"></ion-icon>
                </div>
                <div class="item-content" *ngIf="!isMenuCollapsed">
                  <span class="item-title">Entrar ou Cadastrar</span>
                </div>
              </div>
            </ion-menu-toggle>
          </div>

          <div class="app-version" *ngIf="!isMenuCollapsed">
            <span class="version-text">Versão {{ appVersion }}</span>
          </div>
        </div>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content" style="transition: all 0.3s ease;"></ion-router-outlet>
  </ion-split-pane>
    
  <!-- Global Checkout Button -->
  <app-view-checkout 
    *ngIf="showCheckoutButton && !isOnCheckoutPage"
    [itemCount]="cartItemCount"
    [totalPrice]="cartTotalPrice"
    class="global-checkout-button">
  </app-view-checkout>

  <!-- Floating WhatsApp Help Button -->
  <div class="whatsapp-help-container" *ngIf="whatsappHelpVisible" (click)="navigateMenu('toWhatsapp')">
    <button class="whatsapp-close-btn" (click)="dismissWhatsappHelp($event)">
      <ion-icon name="close"></ion-icon>
    </button>
    <div class="help-bubble">
      <span>Posso ajudar?</span>
    </div>
    <div class="whatsapp-fab">
      <ion-icon name="logo-whatsapp"></ion-icon>
    </div>
  </div>
</ion-app>
